import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import {
  getActiveLanguage,
  getLanguagePrefixedPath,
} from '../../helpers/homepageUrl';

const unitLink = (item, pathname, locale, editPreview) => {
  if (editPreview) {
    return '#';
  }
  if (item.id === 'totes-especialitats-mediques') {
    return getLanguagePrefixedPath(
      pathname,
      locale,
      '/serveis-medics/especialitats',
    );
  }
  return flattenToAppURL(item['@id']);
};

const unitImageUrl = (item) => `${flattenToAppURL(item['@id'])}/@@images/image`;

const UnitatsEspecialitzades = ({ items = [], editPreview = false }) => {
  const { pathname } = useLocation();
  const locale = useSelector((state) => state.intl.locale);

  return (
    <div className="unitatsespecialitzades-container">
      {items.map((item) => {
        if (item.review_state !== 'published') {
          return null;
        }

        const itemContent = (
          <>
            <div
              className="unitatsespecialitzades-item-image"
              style={{
                backgroundImage: `url(${unitImageUrl(item)})`,
              }}
            />
            <p className="unitatsespecialitzades-item-description">
              {item.description}
            </p>
            <h3 className="unitatsespecialitzades-item-title">{item.title}</h3>
          </>
        );

        if (editPreview) {
          return (
            <div
              key={item['@id']}
              className="unitatsespecialitzades-item-container"
            >
              {itemContent}
            </div>
          );
        }

        return (
          <Link
            to={unitLink(item, pathname, locale, editPreview)}
            key={item['@id']}
            className="unitatsespecialitzades-item-container"
          >
            {itemContent}
          </Link>
        );
      })}
    </div>
  );
};

UnitatsEspecialitzades.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  editPreview: PropTypes.bool,
};

UnitatsEspecialitzades.defaultProps = {
  items: [],
  editPreview: false,
};

export default UnitatsEspecialitzades;
